import { ClassicGameId } from './enums/ClassicGameId';
import { TwainGameId } from './enums/TwainGameId';
var GameId = /** @class */ (function () {
    function GameId() {
    }
    GameId.Classic = ClassicGameId;
    GameId.Twain = TwainGameId;
    return GameId;
}());
export { GameId };
